<template>
  <modal @close="modals.transactionHistoryExportModal = false">
      <h3>Transaction History Export</h3>
      <div class="large-form">            
          <div class="form-line">
              <div class="form-field form-field-radio" >
                  <label>CSV History Export Method</label>
                  <div class="radio-option">
                    <input v-model="item.exportMethod" type="radio" value="date-range">
                    <span class="radio-label">Date Range</span>
                  </div>
                  
                  <div class="radio-option">
                    <input v-model="item.exportMethod" type="radio" value="id-range">
                    <span class="radio-label">Transaction ID Range</span>
                  </div>
              </div>
              
              <div class="form-line" v-if="item.exportMethod=='date-range'">
                  <div class="form-field"  style="width: 50%">
                      <label>Starting Date</label>
                      <input type="date" v-model="item.dateStart">
                  </div>
                  <div class="form-field"  style="width: 50%">
                      <label>Ending Date</label>
                      <input type="date" v-model="item.dateEnd">
                  </div>
              </div>
              
              <div class="form-line" v-if="item.exportMethod=='id-range'">
                  <div class="form-field"  style="width: 50%">
                      <label>Starting Transaction ID</label>
                      <input type="number" v-model="item.idStart">
                  </div>
                  <div class="form-field"  style="width: 50%">
                      <label>Ending Transaction ID</label>
                      <input type="number" v-model="item.idEnd">
                  </div>
              </div>
              
          </div>
          <div class="modal-errors">
              <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
          </div>
      </div>
      <div class="form-actions">
          <span class="ws-button ws-button-main" @click="exportTransactionHistory()">GENERATE CSV EXPORT</span>
          <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.transactionHistoryExportModal = false">GO BACK</span>
      </div>
  </modal>
</template>


<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "TransactionHistoryExportModal",
    components: {Modal},
    props: ['lastTransactionId','paymentMethod'],
    data() {
        return {
            item: {
              exportMethod: 'date-range', dateStart: null, dateEnd: null, idStart: 0, idEnd: 0,
            },
            exportParams: {},
            errors: {},
        }
    },
    methods: {
      async fetchData() {
        await this.dispatchWaitAndNotify('fetchTeam', null, false, true);
      },
      setDefaults() {
        const now = new Date();
        const monthAgo = new Date();
        monthAgo.setMonth(monthAgo.getMonth() - 1);
        this.item.dateStart = monthAgo.toISOString().split('T')[0];
        this.item.dateEnd = now.toISOString().split('T')[0];
        this.item.idStart = 1;
        this.item.idEnd = this.lastTransactionId;
      },
      async exportTransactionHistory() {
          if (this.item.exportMethod == 'date-range') this.exportParams = {
                'date-start': this.item.dateStart,
                'date-end': this.item.dateEnd
            };
          else this.exportParams = {
                'id-start': this.item.idStart,
                'id-end': this.item.idEnd
            };
          
          const csvContent = await this.dispatchWaitAndNotify('exportTransactionHistory', this.exportParams);
          var encodedUri = encodeURI("data:text/csv;charset=utf-8,"+csvContent);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", this.csvFileName);
          document.body.appendChild(link); 
          link.click();
          link.remove();
      }
    },
    async mounted() {
      this.fetchData();
      this.setDefaults();
    },
    computed: {
        team() {
            return this.$store.state.team.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        restApiNonce() {
            return window.restApiNonce;
        },
        csvFileName() {
          let date = new Date().toJSON().slice(0,10);  
          if (this.item.exportMethod == 'date-range') return 'ws-transactions-'+this.item.dateStart+'-to-'+this.item.dateEnd+'.csv';     
          else if (this.item.exportMethod == 'id-range') return 'ws-transactions-ids-'+this.item.idStart+'-to-'+this.item.idEnd+'.csv';     
          else return 'ws-trasnactions-team-'+this.team.id+'.csv';
        },
    }
}
</script>

<style scoped>

</style>